var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_9448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27618 3.38342C7.94594 3.38342 8.48889 2.84048 8.48889 2.17072C8.48889 1.50096 7.94594 0.958008 7.27618 0.958008C6.60642 0.958008 6.06348 1.50096 6.06348 2.17072C6.06348 2.84048 6.60642 3.38342 7.27618 3.38342Z",
    stroke: "#2DB5C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42535 6.21252C3.09511 6.21252 3.63806 5.66958 3.63806 4.99982C3.63806 4.33006 3.09511 3.78711 2.42535 3.78711C1.75559 3.78711 1.21265 4.33006 1.21265 4.99982C1.21265 5.66958 1.75559 6.21252 2.42535 6.21252Z",
    stroke: "#2DB5C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27618 9.0426C7.94594 9.0426 8.48889 8.49965 8.48889 7.8299C8.48889 7.16014 7.94594 6.61719 7.27618 6.61719C6.60642 6.61719 6.06348 7.16014 6.06348 7.8299C6.06348 8.49965 6.60642 9.0426 7.27618 9.0426Z",
    stroke: "#2DB5C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47241 5.61035L6.23334 7.21921",
    stroke: "#2DB5C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2293 2.78125L3.47241 4.39011",
    stroke: "#2DB5C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_9448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.70166,
    height: 9.70166,
    fill: "white",
    transform: "translate(0 0.149414)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare4);
export default __webpack_public_path__ + "static/media/share4.b0388d551692e26db3acadd8f09eb77f.svg";
export { ForwardRef as ReactComponent };